import { Component, Schema, type, defaultValue } from "minecs";
@Component()
export class AirportState extends Schema {

    @type("number")
    @defaultValue(0)
    earned: number;
    @type("number")
    @defaultValue(1)
    run: number;
    @type("number")
    @defaultValue(0)
    arrivalLevel: number;
    @type("number")
    @defaultValue(0)
    boots: number;
    @type("number")
    @defaultValue(0)
    bagLevel: number;
    @type("number")
    @defaultValue(0)
    served: number;
    @type("number")
    @defaultValue(0)
    collected: number;
    @type("number")
    @defaultValue(0)
    bagsDelivered: number;
    @type("number")
    @defaultValue(0)
    flights: number;
    @type("number")
    @defaultValue(0)
    puzzles: number;
    @type("number")
    @defaultValue(0)
    upgrades: number;
    @type("number")
    @defaultValue(0)
    workFrames: number;
    @type("number")
    @defaultValue(0)
    manualCheckIns: number;
    @type("number")
    @defaultValue(0)
    mission: number;
    @type("number")
    @defaultValue(0)
    incomeUntil: number;
    @type("number")
    @defaultValue(0)
    expressUntil: number;
    @type("number")
    @defaultValue(0)
    incomeCooldown: number;
    @type("number")
    @defaultValue(0)
    cashCooldown: number;
    @type("number")
    @defaultValue(0)
    expressCooldown: number;
    @type("boolean")
    @defaultValue(false)
    loaded: boolean;
    @type("number")
    @defaultValue(0)
    loadFrame: number;
    @type("number")
    @defaultValue(120)
    spawnClock: number;
    /** Varied interval (frames) until the next arrival; 0 means "use the configured pace". */
    @type("number")
    @defaultValue(0)
    nextArrivalIn: number;
    @type("number")
    @defaultValue(0)
    serial: number;
    @type("string")
    @defaultValue("")
    notice: string;
    @type("number")
    @defaultValue(0)
    noticeUntil: number;
    @type("number")
    @defaultValue(0)
    noticePriority: number;
    @type("number")
    @defaultValue(0)
    revision: number;
    @type("number")
    @defaultValue(0)
    prestigeEpoch: number;
    @type("number")
    @defaultValue(0)
    trashDisposed: number;
    @type("number")
    @defaultValue(0)
    trashLevel: number;
    @type("number")
    @defaultValue(0)
    vendingSales: number;
    @type("number")
    @defaultValue(0)
    chairLevel: number;
    @type("number")
    @defaultValue(0)
    chairUntil: number;
    @type("number")
    @defaultValue(0)
    bootsUntil: number;
    @type("number")
    @defaultValue(0)
    bagsUntil: number;
    @type("number")
    @defaultValue(0)
    cleaningUntil: number;
    @type("number")
    @defaultValue(0)
    shuttleUntil: number;
    @type("number")
    @defaultValue(0)
    pilotCount: number;
    @type("number")
    @defaultValue(0)
    internationalFlights: number;
    @type("number")
    @defaultValue(0)
    routesOpened: number;
    @type("number")
    @defaultValue(0)
    amenityUpgrades: number;
    @type("number")
    @defaultValue(0)
    missionSince: number;
    /** Legacy dissatisfaction counter retained for older saves; no longer reduces arrivals. */
    @type("number")
    @defaultValue(0)
    dissatisfied: number;
    @type("number")
    @defaultValue(80)
    passengerHappiness: number;
    /** Helpers hired this terminal run; prices the first clerk below later roamers. */
    @type("number")
    @defaultValue(0)
    hires: number;
    /** Legacy walkout notice retained for older saves; new queues never trigger it. */
    @type("number")
    @defaultValue(0)
    walkoutUntil: number;
    @type("number")
    @defaultValue(0)
    walkoutX: number;
    @type("number")
    @defaultValue(0)
    walkoutY: number;
    @type("number")
    @defaultValue(0)
    walkoutAmount: number;
    /** Inspection Day streak: departures at least 90% full with no captain working a desk; runtime only, a reload restarts the rush. */
    @type("number")
    @defaultValue(0)
    handsOffFlights: number;
    /** Relaxed pace (host's device setting, applied on build and by the host's command): no walkouts, patience drains at half speed. */
    @type("boolean")
    @defaultValue(false)
    relaxed: boolean;
    /** Next persisted staff record identity; monotonic, so a hire never reuses an earlier identity. */
    @type("number")
    @defaultValue(1)
    nextStaffId: number;
    // Act II shift ledger, Stars and last report (domain/act2.ts OPS_KEYS); persisted as the terminal record's `ops` block.
    @type("number")
    @defaultValue(1)
    shift: number;
    @type("number")
    @defaultValue(0)
    shiftFrames: number;
    @type("number")
    @defaultValue(0)
    shiftEarned: number;
    @type("number")
    @defaultValue(0)
    shiftRetail: number;
    @type("number")
    @defaultValue(0)
    shiftWalkouts: number;
    @type("number")
    @defaultValue(0)
    shiftServed: number;
    @type("number")
    @defaultValue(0)
    shiftWaitSum: number;
    @type("number")
    @defaultValue(0)
    shiftWaitSamples: number;
    @type("number")
    @defaultValue(0)
    shiftLitterSum: number;
    @type("number")
    @defaultValue(0)
    shiftLitterSamples: number;
    @type("number")
    @defaultValue(0)
    shiftComfortSum: number;
    @type("number")
    @defaultValue(0)
    shiftComfortSamples: number;
    @type("number")
    @defaultValue(0)
    shiftDepartures: number;
    @type("number")
    @defaultValue(0)
    shiftOnTime: number;
    @type("number")
    @defaultValue(0)
    starsQueues: number;
    @type("number")
    @defaultValue(0)
    starsClean: number;
    @type("number")
    @defaultValue(0)
    starsComfort: number;
    @type("number")
    @defaultValue(0)
    starsShops: number;
    @type("number")
    @defaultValue(0)
    starsOnTime: number;
    @type("number")
    @defaultValue(0)
    starsOverall: number;
    @type("number")
    @defaultValue(0)
    reportShift: number;
    @type("number")
    @defaultValue(0)
    reportIncome: number;
    @type("number")
    @defaultValue(0)
    reportRetail: number;
    @type("number")
    @defaultValue(0)
    reportWages: number;
    @type("number")
    @defaultValue(0)
    reportAdvance: number;
    @type("number")
    @defaultValue(0)
    reportDepartures: number;
    @type("number")
    @defaultValue(0)
    reportOnTime: number;
    @type("number")
    @defaultValue(0)
    reportWalkouts: number;
    @type("number")
    @defaultValue(0)
    reportStarsBefore: number;
    @type("number")
    @defaultValue(0)
    unpaidShifts: number;
    /** Bags loaded into the hold from the belt, waiting for departing aircraft (MGT-007). */
    @type("number")
    @defaultValue(0)
    holdBags: number;
    /** Fast Track lane at Security (MGT-008): 1 = one lane reserved for premium travellers. */
    @type("number")
    @defaultValue(0)
    fastTrack: number;
    /** MGT-017 policies: service 0 Thrifty / 1 Standard / 2 Premium; boarding 0 Wait for full / 1 On schedule; breaks 0 Late / 1 Early. */
    @type("number")
    @defaultValue(1)
    policyService: number;
    @type("number")
    @defaultValue(0)
    policyBoarding: number;
    @type("number")
    @defaultValue(0)
    policyBreak: number;
    /** Act II stands and airline contracts (domain/contracts.ts AirlineState JSON); empty when unused. */
    @type("string")
    @defaultValue("")
    airline: string;
    // Act II events and crises (domain/events.ts), reset every shift.
    @type("number")
    @defaultValue(0)
    eventKind: number;
    @type("number")
    @defaultValue(0)
    eventAt: number;
    @type("number")
    @defaultValue(0)
    eventAnnounced: number;
    @type("number")
    @defaultValue(0)
    eventDone: number;
    @type("number")
    @defaultValue(0)
    crisis0: number;
    @type("number")
    @defaultValue(0)
    crisis1: number;
    @type("number")
    @defaultValue(0)
    crisis2: number;
    @type("number")
    @defaultValue(0)
    crisisAge0: number;
    @type("number")
    @defaultValue(0)
    crisisAge1: number;
    @type("number")
    @defaultValue(0)
    crisisAge2: number;
    @type("number")
    @defaultValue(0)
    crisisHold0: number;
    @type("number")
    @defaultValue(0)
    crisisHold1: number;
    @type("number")
    @defaultValue(0)
    crisisHold2: number;
    @type("number")
    @defaultValue(0)
    crisisGate0: number;
    @type("number")
    @defaultValue(0)
    crisisGate1: number;
    @type("number")
    @defaultValue(0)
    crisisGate2: number;
    @type("number")
    @defaultValue(0)
    crisesRolled: number;
    @type("number")
    @defaultValue(0)
    crisisTypes: number;
    @type("number")
    @defaultValue(0)
    crisisRewards: number;
    /** A ferry wave passed with no walkouts (MGT-023), and the walkout count when it landed. */
    @type("number")
    @defaultValue(0)
    ferryClean: number;
    @type("number")
    @defaultValue(0)
    ferryBase: number;
    /** Serial range of the last ferry wave and how many of its tourists walked out (MGT-023). */
    @type("number")
    @defaultValue(0)
    ferryFirst: number;
    @type("number")
    @defaultValue(0)
    ferryLast: number;
    @type("number")
    @defaultValue(0)
    ferryWalkouts: number;
    /** MGT-024 shift goals (domain/act2.ts pickGoals) and the last shift's results as a bitmask. */
    @type("number")
    @defaultValue(0)
    goal0: number;
    @type("number")
    @defaultValue(0)
    goal1: number;
    @type("number")
    @defaultValue(0)
    goal2: number;
    @type("number")
    @defaultValue(0)
    goalTarget0: number;
    @type("number")
    @defaultValue(0)
    goalTarget1: number;
    @type("number")
    @defaultValue(0)
    goalTarget2: number;
    @type("number")
    @defaultValue(0)
    goalsMet: number;
    /** Crises fixed by a captain at this airport (Bayview takeover beat, MGT-022). */
    @type("number")
    @defaultValue(0)
    crisesFixed: number;
    /** Desk helpers based at Security, refreshed each frame for the takeover beat (runtime only). */
    @type("number")
    @defaultValue(0)
    securityHelpers: number;
    /** MGT-006 department tiers (0-2 = tier 1-3) and the retail slot module (0 Duty Free, 1 Café, 2 Gift Shop). */
    @type("number")
    @defaultValue(0)
    tier0: number;
    @type("number")
    @defaultValue(0)
    tier1: number;
    @type("number")
    @defaultValue(0)
    tier2: number;
    @type("number")
    @defaultValue(0)
    tier3: number;
    @type("number")
    @defaultValue(0)
    tier4: number;
    @type("number")
    @defaultValue(0)
    tier5: number;
    @type("number")
    @defaultValue(0)
    tier6: number;
    @type("number")
    @defaultValue(0)
    tier7: number;
    @type("number")
    @defaultValue(0)
    retailModule: number;
}
